import { useMemo } from "react";
import {
	useProductConfigApplier,
	useProductConfigApplierFromState
} from "../../hooks/useProductConfigApplier";
import getProductConfigFromQuery from "../../utils/queryProductConfig";

const ModelProductConfigFromState = ({ getIsReady, renderingApi }) => {
	useProductConfigApplierFromState(getIsReady, renderingApi);
	return null;
};

//in charge of reading the encoded product-config info from the URL and decode it into the json config
const ModelProductConfigFromQuery = ({ getIsReady, renderingApi }) => {
	const productConfig = useMemo(getProductConfigFromQuery, []);

	useProductConfigApplier(getIsReady, renderingApi, productConfig);
	return null;
};

export {
	ModelProductConfigFromState,
	ModelProductConfigFromQuery,
};
